import { useState } from 'react';

const useToggleOpen = (startOpen = false) => {
  const [open, setOpen] = useState(startOpen);
  const toggleOpen = () => setOpen((prevOpen) => !prevOpen);
  return ({ open, toggleOpen });
};

export { useToggleOpen };
